var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.store.ballsInFeed),function(ball){return _c('p',{key:ball.id},[_c('span',[_vm._v(_vm._s(ball.author_name)+":")]),_vm._v("\n    "+_vm._s(ball.message)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84067a4c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/BallsFeed.vue
// module id = 120
// module chunks = 0